import React, { useEffect, useState } from "react";
import axios from "axios";
import Brands1 from "../components/brands/Brands1";
import BreadcrumbsHeader from "../components/breadcrumbs/BreadcrumbsHeader";

const Media = () => {
  const [mediaList, setMediaList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("https://www.isolsgroup.com/new/api/ApiPressRelease", {
        headers: {
          "X-API-KEY": "ISOLS",
        },
      })
      .then((res) => {
        console.log("API Response:", res.data);
        if (res.data && Array.isArray(res.data.data)) {
          setMediaList(res.data.data);
        } else {
          setMediaList([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching media:", err);
        setLoading(false);
      });
  }, []);

  const formatDate = (dateStr) => {
    const [day, month, year] = dateStr.split("/");
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    return `${months[parseInt(month) - 1]} ${day} ${year}`;
  };

  return (
    <div className="page-container">
      {/* Breadcrumbs Header */}
      <BreadcrumbsHeader 
        title="Media - Talk of the Town" 
        backgroundImage="/images/header/media-cover.jpg" 
      />




      {/* About / Intro Section */}
      <section className="section-blog">
        <div className="container">
          <div className="row">
            <div className="b-mod-heading text-center">
              <p className="second-heading font-additional">
                We as ISOLIANS strive to create an impact using technology &
                digital innovation and revolution for empowering the
                small-medium enterprises (SMEs) and unorganized industry
                verticals. Various print and TV media have been supporting our
                initiatives so as to reach untapped SMEs. For any media/PR
                related inquiry you can write to us at{" "}
                <a href="mailto:pr@isolsgroup.com">pr@isolsgroup.com</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Media / News Section */}
      <section className="section-blog">
        <div className="container">
          <div className="row">
            <div className="b-home-news relative">
              <div className="container">
                <div className="row">
                  {loading ? (
                    <p className="text-center">Loading media...</p>
                  ) : mediaList.length > 0 ? (
                    mediaList.map((item, index) => {
                      const imgLeft = index % 2 === 0;
                      return (
                        <div
                          key={index}
                          className={`col-xs-12 col-sm-6 col-md-6 col-lg-6 wow ${
                            imgLeft ? "fadeInDown" : "fadeInUp"
                          }`}
                          style={{
                            visibility: "visible",
                            animationName: imgLeft ? "fadeInDown" : "fadeInUp",
                          }}
                        >
                          <div
                            className={`primary-home-news ${
                              imgLeft ? "primary-news-1" : "primary-news-2"
                            }`}
                          >
                            <div className="row">
                              {imgLeft && (
                                <div className="col-xs-12 col-sm-6">
                                  <div className="b-blog-img">
                                    <img
                                      src={`https://www.isolsgroup.com/uploaded-images/media-release/${item.image}`}
                                      className="img-responsive center-block"
                                      alt={item.title}
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="col-xs-12 col-sm-6">
                                <div className="b-blog-caption">
                                  <div className="caption-data customPseudoElBg">
                                    <span className="date">
                                      {formatDate(item.edate)}
                                    </span>
                                    <span className="author">admin</span>
                                  </div>
                                  <h4 className="caption-title">{item.heading	}</h4>
                                  <div className="caption-preview-text">
                                    <p>{item.short_desc?.replace(/<[^>]+>/g, '')}</p>
                                  </div>
                                </div>
                              </div>
                              {!imgLeft && (
                                <div className="col-xs-12 col-sm-6">
                                  <div className="b-blog-img img-cut cut-left-bottom">
                                    <div className="cut"></div>
                                    <img
                                      src={`https://www.isolsgroup.com/uploaded-images/media-release/${item.image}`}
                                      className="img-responsive center-block"
                                      alt={item.title}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-center">No media coverage available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row" style={{ marginBottom: "45px" }}>
            <center>
              <p style={{ fontSize: "17px" }}>
                For any media or press release enquiry kindly email us at{" "}
                <a href="mailto:info@isolsgroup.com">info@isolsgroup.com</a>
              </p>
            </center>
          </div>
        </div>
      </section>

      <Brands1 />
    </div>
  );
};

export default Media;
